import { jsx as _jsx } from "react/jsx-runtime";
import { defaultDateFormat } from "../date/detail";
import DateTimeFieldDetail from "../datetime/detail";
import { FieldViewType } from "../viewType";
export default function DatetimeFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, _b = _a.format, format = _b === void 0 ? defaultDateFormat : _b;
    return (_jsx(DateTimeFieldDetail, { fieldName: fieldName, record: record, format: format, viewType: FieldViewType.DETAIL }));
}
